import * as React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useDialog } from "context/Dialog";
import { useTranslation } from "react-i18next";
import maintenance from "assets/image/maintenance.png";
import { styled } from "@mui/material/styles";

const StyledAlert = styled(Alert)`
  font-size: 1.125rem;
  font-weight: 500;
  display: flex;
  padding-left: 50px;
  /* margin-top: 10px; */
  color: #6D4E00;
  ${(props) => props.theme.breakpoints.down("sm")} {
    margin-top: -5px;
    font-size: 0.875rem;
    padding-left: 16px;
  }
`;

const MaintenanceNotic = ({ details, formDate, toDate, state, handleCloseNoti }) => {
  const { getDialog } = useDialog();
  const { t } = useTranslation(["translation"]);
  const handleShowDetail = () => {
    getDialog({
      type: "info",
      variant: "warning",
      img: maintenance,
      title: (
        <div>
          <div>{t("maintenance.temporary_close")}</div>
          <div style={{ fontWeight: 500, fontSize: "1.125rem" }}>
            {t("maintenance.dialog_description", {
              date: `${dayjs(formDate).format(t("formatDate.keyboardDate"))}`,
              fromDate: `${dayjs(formDate).format(t("formatDate.time"))}`,
              toDate: `${dayjs(toDate).format(t("formatDate.time"))}`,
            })}
          </div>
        </div>
      ),
      description: (
        <div style={{ marginTop: "10px" }}>
          {t("maintenance.featureadd")}
          <ul
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "left",
              margin: "0px",
            }}
          >
            {details &&
              details.map((item, index) => <li key={index}>{item}</li>)}
          </ul>
        </div>
      ),
    });
  };

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Collapse in={state}>
          <StyledAlert
            severity="warning"
            icon={false}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleCloseNoti}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {t("maintenance.title", {
              date: `${dayjs(formDate).format(t("formatDate.keyboardDate"))}`,
              fromDate: `${dayjs(formDate).format(t("formatDate.time"))}`,
              toDate: `${dayjs(toDate).format(t("formatDate.time"))}`,
            })}
            <span
              style={{
                marginLeft: "10px",
                textDecoration: "underline",
                color: "#4B9752",
                cursor: "pointer",
                fontSize: "1rem",
              }}
              onClick={handleShowDetail}
            >
              {t("maintenance.detail")}
            </span>
          </StyledAlert>
        </Collapse>
      </Box>
    </div>
  );
};

export default MaintenanceNotic;
